// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".warning[data-v-f32aee7c]{background-color:var(--warning);padding:var(--spacing-2);display:flex;flex-direction:row;align-items:center;margin:var(--spacing-4) var(--spacing-2)}.warning>p[data-v-f32aee7c]{margin-bottom:0;margin-top:0}.icon[data-v-f32aee7c],.warning>p[data-v-f32aee7c]{color:var(--black)}.icon[data-v-f32aee7c]{font-size:2em;margin-right:var(--spacing-2);font-weight:700}.warning>.description>a[data-v-f32aee7c]{color:var(--black)}", ""]);
// Exports
module.exports = exports;
